//
import React from 'react';
import {PropTypes} from 'prop-types';

class Iframe extends React.Component {
  constructor(props) {
    super(props);
    //
    this.elementRef = React.createRef();
    this.adjustTimeout = null;
    this.mutationObserver = null;
  }

  componentDidMount() {
    this.adjustHeight();
  }

  componentDidUpdate() {
    this.adjustHeight();
  }

  componentWillUnmount() {
    clearTimeout(this.adjustTimeout);
    //
    this.clearListeners();
  }

  onWindowResize = () => {
    this.adjustHeight();
  }

  adjustHeight = () => {
    if (this.props.autoAdjustHeight) {
      this.adjustTimeout = setTimeout(() => {
        const iframe = this.elementRef.current;
        //
        if (iframe && iframe.contentWindow &&
          iframe.contentWindow.document &&
          iframe.contentWindow.document.body) {

          let contentHeight = iframe.contentWindow.document.body.scrollHeight || 0;
          const collection = iframe.contentWindow.document.querySelectorAll("p, h1, h2, h3, h4, h5, h6, ol, ul, li, pre, address, blockquote, dl, div, fieldset, form, hr, table, iframe");
          //  IE11 non vede forEach su nodeList => conversione in array 
          Array.prototype.slice.apply(collection).forEach(element => {
            if ((element.visibility !== 'hidden') && (element.scrollHeight > contentHeight)) {
              contentHeight = element.scrollHeight;
            }
          });

          if (iframe.height !== contentHeight) {
            iframe.height = contentHeight;
            setTimeout(function() {
              const h = iframe.contentWindow.document.querySelector('html');
              if (h && h.scrollHeight) {
                iframe.height = h.scrollHeight;
              }
            }, 200
            );
            
          }


        }
      }, 200);
    }
    //  this.elementRef.current.height = this.elementRef.current.contentWindow.document.body.scrollHeight || 'auto';
  }

  clearListeners = () => {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
    //
    const iframe = this.elementRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.removeEventListener("resize", this.onWindowResize);
    }
  }

  initListeners = () => {
    this.clearListeners();
    //
    const iframe = this.elementRef.current;
    if (iframe && iframe.hasOwnProperty('height')) {
      iframe.height = 'auto';
      iframe.contentWindow.addEventListener("resize", this.onWindowResize);
    }

    this.mutationObserver = new MutationObserver((mutations) => {
      this.adjustHeight();
    });
    
    this.mutationObserver.observe(iframe.contentDocument.body, { 
      attributes: true,
      attributesFilter: ['style'],
      subtree: true,
      childList: true
    });
    //
    this.adjustHeight();
  }

  render() {
    const {src, scrolling, width, height} = this.props;

    return(
      <iframe src={src} scrolling={scrolling} width={width} height={height} ref={this.elementRef} onLoad={this.initListeners}/>
    );
    //  onLoad={this.adjustHeight}  
  }

  
}

Iframe.defaultProps = {
  src: '',
  scrolling: 'no',
  width: 'auto',
  height: 'auto',
  autoAdjustHeight: true
};

Iframe.propTypes = {
  src: PropTypes.string,
  scrolling: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  autoAdjustHeight: PropTypes.bool
};

export default Iframe;